import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/schoolAuth/apply',
    name: 'schoolAuthApply',
    component: () => import('@/sub-app/schoolAuth/pages/apply.vue'),
    meta: {
      title: '学校认证', 
      keepAlive: true,
    },
  },
  {
    path: '/schoolAuth/applyResult',
    name: 'schoolAuthResult',
    component: () => import('@/sub-app/schoolAuth/pages/applyResult.vue'),
    meta: {
      title: '学校认证', 
      keepAlive: true,
    },
  },
  {
    path: '/schoolAuth/authList',
    name: 'schoolAuthauthList',
    component: () => import('@/sub-app/schoolAuth/pages/authList.vue'),
    meta: {
      title: '学校认证', 
      keepAlive: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  document.title = to.meta?.title || '';
  next();
});

export default router;
